import React from 'react';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { StyledFormGroup, Feedback, SPECIALIZATIONS } from './Common';

const ExamSelection = ({
    eligibleExamLevels,
    register,
    errors,
    selectedSpecialization,
    setSelectedSpecialization,
    selectedExamLevel,
    setSelectedExamLevel,
    examSelections,
    handleAddSelection,
    handleRemoveSelection,
    totalAmount
}) => {
    return (
        <>
            <hr />
            <h5 className="mt-3">Exam Selection</h5>
            <Row>
                <StyledFormGroup as={Col} md="6">
                    <Form.Label>Specialization <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                        {...register("specialization")}
                        isInvalid={!!errors.specialization}
                        value={selectedSpecialization}
                        onChange={(e) => setSelectedSpecialization(e.target.value)}
                    >
                        <option value="">Select Specialization</option>
                        {SPECIALIZATIONS.map((sp) => (
                            <option key={sp} value={sp}>{sp}</option>
                        ))}
                    </Form.Select>
                    <Feedback error={errors.specialization} />
                </StyledFormGroup>

                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Exam Level <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                        {...register("examLevel")}
                        isInvalid={!!errors.examLevel}
                        value={selectedExamLevel}
                        onChange={(e) => setSelectedExamLevel(e.target.value)}
                    >
                        <option value="">Select Level</option>
                        {eligibleExamLevels.map((lvl) => (
                            <option key={lvl} value={lvl}>{lvl}</option>
                        ))}
                    </Form.Select>
                    <Feedback error={errors.examLevel} />
                    {eligibleExamLevels.length === 0 && (
                        <div className="text-muted small mt-1">Select a Year first to load eligible exam levels.</div>
                    )}
                </StyledFormGroup>

                <Col md="2" className="d-flex align-items-center mt-2">
                    <Button className="w-100" onClick={handleAddSelection}>Add</Button>
                </Col>
            </Row>

            {errors.examSelections && (
                <div className="text-danger mt-2">{errors.examSelections?.message}</div>
            )}

            {examSelections.length > 0 && (
                <Card className="mt-3 p-3">
                    <h6>Selected Exams</h6>
                    {examSelections.map((item, index) => (
                        <div key={index} className="d-flex justify-content-between align-items-center mb-2">
                            <span>{item.specialization} — {item.examLevel} — ₹{item.fee}</span>
                            <Button
                                variant="danger"
                                size="sm"
                                className="d-flex align-items-center justify-content-center rounded-circle"
                                style={{ width: "32px", height: "32px", padding: 0 }}
                                onClick={() => handleRemoveSelection(index)}
                            >
                                <RiDeleteBin6Line size={18} />
                            </Button>
                        </div>
                    ))}
                    <hr />
                    <h6>Total Amount: ₹{totalAmount}</h6>
                </Card>
            )}
        </>
    );
};

export default ExamSelection;
